module.exports = __webpack_public_path__ + "static/media/cases_3d_keslon_03a.b2129407.jpg";